import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { TabsPage } from "./tabs.page";
import { AuthGuard } from "../guards/auth.guard";

const routes: Routes = [
  {
    path: "tabs",
    component: TabsPage,
    children: [
      {
        path: "inventory",
        children: [
          {
            path: "",
            loadChildren:
              "../pages/inventory/inventory.module#InventoryPageModule",
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "Offtopic",
        children: [
          {
            path: "",
            loadChildren:
              "../pages/offtopic/offtopic.module#OfftopicPageModule",
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "map",
        children: [
          {
            path: "",
            loadChildren: "../pages/map/map.module#MapPageModule",
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "analytics",
        children: [
          {
            path: "",
            loadChildren:
              "../pages/analytics/analytics.module#AnalyticsPageModule",
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "tab1",
        children: [
          {
            path: "",
            loadChildren:
              "../pages/offers/list/list-offer.module#ListOfferModule",
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "tab2",
        children: [
          {
            path: "",
            loadChildren:
              "../pages/offers/list/list-offer.module#ListOfferModule",
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "pending/:type",
        children: [
          {
            path: "",
            loadChildren:
              "../pages/offers/new/pending/pending.module#PendingPageModule",
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "pending/:type/:mailing",
        children: [
          {
            path: "",
            loadChildren:
              "../pages/offers/new/pending/pending.module#PendingPageModule",
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "tab4",
        children: [
          {
            path: "",
            loadChildren:
              "../pages/settings/profile/profile.module#ProfilePageModule",
            canActivate: [AuthGuard],
          },
          {
            path: "company",
            loadChildren:
              "../pages/settings/company/company.module#CompanyPageModule",
            canActivate: [AuthGuard],
          },
          {
            path: "password",
            loadChildren:
              "../pages/settings/change-password/change-password.module#ChangePasswordPageModule",
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "notifications",
        children: [
          {
            path: "",
            loadChildren:
              "../pages/notifications/notifications.component.module#NotificationsComponentModule",
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "",
        redirectTo: "/tabs/tab1",
        pathMatch: "full",
      },
    ],
  },
  {
    path: "",
    redirectTo: "/tabs/tab1",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TabsPageRoutingModule { }
